<template>
  <v-container>
    <div class="pp">住所検索サイト（以下、「本サイト」といいます。）は、関西電力株式会社および株式会社エアフロント（以下、「運営者」といいます。）が運営しています。
      ご利用にあたっては、以下のご利用条件をお読みいただき、ご同意の上、ご利用ください。
      運営者は、予告なしに利用条件を変更することがあります。その際には、この規約の改訂版を本サイト掲載いたしますので、最新の内容をご確認いただきますようお願い申しあげます。
      ＜基本情報＞
      第一条　個人情報の収集と利用
      　運営者は、収集目的を明確にした上で、目的の範囲内に限り、個人情報を収集します。
      また、個人情報の利用は、その収集目的から逸脱しない範囲とします。

      第二条　個人情報の管理と保護
      　個人情報の管理は、厳重に行うこととし、ご利用者にご承諾いただいた場合を除き、第三者に対しデータを開示・提供することはいたしません。また、個人情報に関する不正アクセス、紛失、破壊、改ざん、漏洩を防ぐための適切な処置を行います。

      第三条　準拠法等
      　運営者は、運営者が保有する個人情報に関して適用される法令、規範を遵守します。

      ＜個人情報の取り扱い＞
      運営者が提供する本サイトにおけるご利用者の個人情報の取り扱いを以下に定めます。
      ■情報の取得者
      関西電力株式会社および株式会社エアフロントが共同で取得します。
      ■取得する情報
      　本サイトのご利用に際して、位置情報を必要とする場合は、端末の位置情報（GPS、ネットワークを利用した位置情報）を取得します。
      ■利用目的
      　位置情報を利用した住所情報の提供およびご利用場所の取得に利用します。
      ■取得方法
      位置情報が必要な本サイトへのアクセス、または位置情報から住所情報を取得する設定を行った場合にのみ、端末から取得します。
      ■外部送信
      取得された情報は本サイトの設置するサーバーに転送され、目的の範囲で使用します。
      ■変更
      ご利用者情報の取得項目の変更や追加、利用目的の変更、第三者提供等について変更がある場合には、本サイト内でお知らせします。
      ■共同利用の管理責任者
      　株式会社エアフロント
      ■同意
      本サイトは、本個人情報の取り扱いをご確認いただき、内容を理解したうえでご利用ください。なお、ご利用者が端末の位置情報機能をOFFにすることで、位置情報の取得は停止されます。
    </div>
    <div style="text-align:center" v-if="!isAuthorized">
      <router-link to="login" replace>ログイン画面に戻る</router-link>
    </div>
  </v-container>
</template>

<script>
import {isAuthorized} from '@/lib/common'

export default {
  name: 'PrivacyPolicy',
  created () {
    this.$router.afterEach(() => {
      this.isAuthorized = isAuthorized()
    })
  },
  data () {
    return {
      isAuthorized: isAuthorized()
    }
  }
}
</script>

<style scoped>
  .pp {
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue